import axios from "@/api/axios";

const getVisitorList = (data) => {
    return axios
        .post('/admin/reception/visitors-list', {visitor: data})
        .then(response => response.data)
}

const desktopClient = data => {
    return axios
        .post('/admin/reception/desktop-client',{client: data})
        .then(response => response.data)
}

const desktopClientCard = data => {
    return axios
        .post('/admin/reception/desktop-client-card',{client: data})
        .then(response => response.data)
}

const desktopClientSale = data => {
    return axios
        .post('/admin/reception/desktop-client-sale',{client: data})
        .then(response => response.data)
}

const documentRemove = data => {
    return axios
        .post('/admin/reception/document-remove',{client: data})
        .then(response => response.data)
}

export default {
    getVisitorList,
    desktopClient,
    desktopClientCard,
    desktopClientSale,
    documentRemove
}